var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item.type === 'textarea')?_c('a-textarea',{attrs:{"disabled":_vm.item.isDisabled,"placeholder":_vm.item.placeholder || '',"rows":_vm.item.rows ? _vm.item.rows + '' : null,"id":_vm.item.props},on:{"click":function (e) {
                    _vm.clickHandle(e, _vm.item);
                },"change":function (e) {
                    _vm.debounceHandle(e, _vm.item);
                },"blur":function (e) {
                    _vm.blurHandle(e, _vm.item);
                }},model:{value:(_vm.textAreaVal),callback:function ($$v) {_vm.textAreaVal=$$v},expression:"textAreaVal"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }